export default "__VITE_ASSET__71466ff5__"